module.exports = __webpack_public_path__ + "img/experience-1.2baf4616.png";